// import React from 'react';
import PageHelmet from '../Helper/PageHelmet';
import Header from '../Helper/Header';
import Footer from '../Helper/Footer';

import HeroSection from './HeroSection';
import FeaturesSection from './FeaturesSection';
import ClientSection from './ClientSection';
// import PartnerSection from './PartnerSection';
import FaqSection from './FaqSection';
import ContactSection from './ContactSection';

const Home = () => {
    return (
        <>
            <PageHelmet pageTitle="E-Learning Solutions, E-Learning Service Providers in India" />
            <Header />
            <HeroSection />
            <FeaturesSection />
            <ClientSection />
            {/* <PartnerSection /> */}
            <FaqSection />
            <ContactSection />
            <Footer />
        </>
    );
};

export default Home;